import { render, staticRenderFns } from "./page.vue?vue&type=template&id=c154f378&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=c154f378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c154f378",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AlturaButton: require('/app/node_modules/@altura/components/components/Button.vue').default,DetailSummaryEnhancer: require('/app/components/detail/SummaryEnhancer.vue').default,FollowButton: require('/app/components/FollowButton.vue').default,AlturaShareCard: require('/app/node_modules/@altura/components/components/ShareCard.vue').default,AlturaDropdown: require('/app/node_modules/@altura/components/components/Dropdown.vue').default,DetailTranslationButton: require('/app/components/detail/TranslationButton.vue').default,AlturaContainer: require('/app/node_modules/@altura/components/components/Container.vue').default,DetailMainInfo: require('/app/components/detail/MainInfo.vue').default,DetailDocumentTabs: require('/app/components/detail/DocumentTabs.vue').default,DetailCompetition: require('/app/components/detail/Competition.vue').default,DetailRelatedTenders: require('/app/components/detail/RelatedTenders.vue').default})
